// components/MuiTooltip.tsx
import React from "react";
import Tooltip from "@mui/material/Tooltip";
import { TooltipProps } from "@mui/material/Tooltip";

interface MuiTooltipProps
  extends Omit<TooltipProps, "title" | "children" | "placement"> {
  title: React.ReactNode;
  children: React.ReactElement;
}

const MuiTooltip: React.FC<MuiTooltipProps> = ({
  title,
  children,
  ...props
}) => {
  return (
    <Tooltip title={title} placement="top-start" arrow {...props}>
      {children}
    </Tooltip>
  );
};

export default MuiTooltip;
